/** Where every attachment of a sourcing request, or of one item, downloads as a zip. */
export function attachmentsZipUrl(
  sourcingRequestId: string,
  itemId?: string,
): string {
  const base = `/api/sourcing-request/${encodeURIComponent(
    sourcingRequestId,
  )}/attachments`;

  return itemId ? `${base}?itemId=${encodeURIComponent(itemId)}` : base;
}
